export const column = [
  { header: 'No.', value: 'no' },
  { header: 'Nama Lengkap', value: 'name' },
  { header: 'Jenis Mobil', value: 'car_type' },
  { header: 'Mulai Sewa', value: 'start_date' },
  { header: 'Selesai Sewa', value: 'end_date' },
  { header: 'Jam Sewa', value: 'start_time' },
  { header: 'Total Harga', value: 'total_payment' },
  { header: 'Status Pembayaran', value: 'status' },
];

export const columnExtend = [
  { header: 'No.', value: 'no' },
  { header: 'Nama Lengkap', value: 'name' },
  { header: 'Jenis Mobil', value: 'car_type' },
  { header: 'Mulai Sewa', value: 'start_date' },
  { header: 'Selesai Sewa', value: 'end_date' },
  { header: 'Jam Sewa', value: 'start_time' },
  // { header: 'Total Harga', value: 'total_payment' },
  // { header: 'Status Pembayaran', value: 'status' },
  // { header: 'Status Sewa', value: 'rent_status' },
];

export const refundColumn = [
  { header: 'No.', value: 'no' },
  { header: 'Nama Lengkap', value: 'name' },
  { header: 'Jenis Mobil', value: 'car_type' },
  { header: 'Mulai Sewa', value: 'start_date' },
  { header: 'Selesai Sewa', value: 'end_date' },
  { header: 'Jam Sewa', value: 'start_time' },
  { header: 'Total Harga', value: 'total_payment' },
  { header: 'Status Pengembalian', value: 'status_cancelation' },
];

export const columnReview = [
  { header: 'No.', value: 'no' },
  { header: 'Nama Lengkap', value: 'name' },
  { header: 'Jenis Mobil', value: 'car_type' },
  { header: 'Tanggal Sewa', value: 'start_date' },
];

export const depositColumn = [
  { header: 'No.', value: 'no' },
  { header: 'Nama Lengkap', value: 'name' },
  { header: 'Kode Order', value: 'order_key' },
  { header: 'Jumlah Deposit', value: 'booking_deposit' },
  { header: 'Status', value: 'status' },
];

export const withoutDriverColumn = [
  { header: 'No.', value: 'no' },
  { header: 'Nama Lengkap', value: 'name' },
  { header: 'Jenis Mobil', value: 'car_type' },
  { header: 'Mulai Sewa', value: 'start_date' },
  { header: 'Selesai Sewa', value: 'end_date' },
  { header: 'Jam Sewa', value: 'start_time' },
  { header: 'Status Sewa', value: 'status' },
  { header: 'Status Pembayaran', value: 'type' },
  { header: 'Asal Sumber Pesanan', value: 'platform' },
  { header: 'Rating Pesanan', value: 'rating' },
];

export const airportTransferColumn = [
  { header: 'No.', value: 'no' },
  { header: 'Nama Lengkap', value: 'name' },
  { header: 'Kategori Mobil', value: 'package_type' },
  { header: 'Pick Up Date', value: 'start_date' },
  { header: 'Pick Up Time', value: 'start_time' },
  { header: 'Status Pembayaran', value: 'type' },
  { header: 'Status Order', value: 'status' },
  { header: 'Asal Sumber Pesanan', value: 'platform' },
  { header: 'Rating Pesanan', value: 'rating' },
];

export const carCharterColumn = [
  { header: 'No.', value: 'no' },
  { header: 'Nama Lengkap', value: 'name' },
  { header: 'Jenis Mobil', value: 'car_type' },
  { header: 'Mulai Sewa', value: 'start_date' },
  { header: 'Selesai Sewa', value: 'end_date' },
  { header: 'Jam Sewa', value: 'start_time' },
  { header: 'Status Sewa', value: 'status' },
  { header: 'Status Pembayaran', value: 'type' },
  { header: 'Asal Sumber Pesanan', value: 'platform' },
  { header: 'Rating Pesanan', value: 'rating' },
];
